function scrollreveal(el){
	el.each(function() {
		if ($(window).scrollTop() + $(window).height() > $(this).offset().top) {
			$(this).addClass('in-view');
		} else {
			$(this).removeClass('in-view');
		}
	});
}

jQuery(document).ready(function() {
	$(window).on('scroll resize', function() {
		scrollreveal($("section .container div[class^='ce-']"));
	});
scrollreveal($("section .container div[class^='ce-']"));
});

$(window).scroll(function() {
    var nav = $('header');
    var top = 200;
    if ($(window).scrollTop() >= top) {

        nav.addClass('scrolled');

    } else {
        nav.removeClass('scrolled');
    }
});


// WEBPACK FOOTER //
// ./js/parts/animation.js